module.exports = __webpack_public_path__ + "img/ccl_main2.499e8c28.jpg";